import { Sparkle } from "lucide-react";
import { MARQUEE } from "@/lib/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((m) => (
      <span key={m} className="flex items-center">
        <span className="px-8 sm:px-12 text-4xl sm:text-6xl lg:text-7xl font-serif-i text-brand">
          {m}
        </span>
        <Sparkle className="h-6 w-6 sm:h-8 sm:w-8 text-cyan-300 shrink-0" strokeWidth={1.2} />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section className="marquee-wrap relative border-y border-cyan-400/15 bg-[#0c1222]/60 py-8 sm:py-12 overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </section>
  );
}
